/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { questionDataAttributeSchema } from './QuestionDataAttributeSchema'
import { questionDataSubtypeSchema } from './QuestionDataSubtypeSchema'
import { questionDataTypeSchema } from './QuestionDataTypeSchema'

export const questionDataSchema = z.object({
	id: z.string().nullable(),
	label: z.string(),
	type: questionDataTypeSchema,
	attribute: questionDataAttributeSchema.nullable(),
	subtype: questionDataSubtypeSchema.nullable(),
	validationRules: z.array(z.string()).nullable(),
	position: z.number(),
	options: z.array(
		z.object({
			id: z.string().uuid(),
			label: z.string(),
			position: z.number(),
			consentType: z.string().nullable(),
			escoSkills: z.array(
				z.object({ conceptUri: z.string(), preferredLabel: z.string(), confirmedByUser: z.boolean() }),
			).nullable(),
			escoMappingReason: z.string().nullable(),
		}),
	).nullable(),
	updatedAt: z.iso.datetime(),
})

export type QuestionDataSchema = z.infer<typeof questionDataSchema>
